import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phone", "countryCode", "emailWrapper", "email"]
  static values = { initialCountry: String }

  async connect() {
    if (!this.hasPhoneTarget) return;

    const module = await import("intl-tel-input");
    const intlTelInput = module.default || module;
    this.intlTelInput = intlTelInput;

    const initialCountry = (this.hasInitialCountryValue && this.initialCountryValue)
      ? this.initialCountryValue.toLowerCase()
      : "in"

    this.iti = intlTelInput(this.phoneTarget, {
      initialCountry,
      separateDialCode: true,
      countrySearch: true,
      placeholderNumberPolicy: "AGGRESSIVE",
      placeholderNumberType: "MOBILE",
      strictMode: true,
      // Lazy-load the heavy (~259KB) utils as a separate Propshaft-served asset URL
      // instead of bundling it into application.js. A dynamic-URL import keeps esbuild
      // from pulling utils into the main bundle.
      loadUtils: () => import(window.MediFyrAssets?.itlUtils || "intl-tel-input/utils"),
      dropdownParent: document.body
    });
    this.updateUI();
    const scheduleUpdate = () => requestAnimationFrame(() => this.updateUI());
    this.phoneTarget.addEventListener("countrychange", scheduleUpdate);
    this.phoneTarget.addEventListener("input", scheduleUpdate);

    const form = this.element.closest("form")
    if (form) {
      this._onSubmit = () => { this.phoneTarget.value = this.phoneTarget.value.replace(/\D/g, "") }
      form.addEventListener("submit", this._onSubmit)
      this._submitForm = form
    }
  }

  disconnect() {
    if (this._submitForm && this._onSubmit) {
      this._submitForm.removeEventListener("submit", this._onSubmit)
    }
  }

  updateUI() {
    const country = this.iti.getSelectedCountry()
    if (!country) return
    const iso = country.iso2
    const isIN = iso === "in"

    if (this.phoneTarget.value.trim() === "") {
      this.phoneTarget.setCustomValidity("")
    } else if (this.intlTelInput && this.intlTelInput.utils) {
      this.phoneTarget.setCustomValidity(this.iti.isValidNumber() ? "" : "Please enter a valid phone number")
    } else {
      this.phoneTarget.setCustomValidity("")
    }

    const dialCode = `+${country.dialCode}`
    if (this.hasCountryCodeTarget) this.countryCodeTarget.value = dialCode
    if (this.hasEmailWrapperTarget && this.hasEmailTarget) {
      this.emailWrapperTarget.style.display = isIN ? "none" : "block"
      this.emailTarget.required = !isIN
    }
  }
}
